import { useState } from 'react'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { BasicResponse, HttpError, HttpErrorMessageType } from '@eo-storefronts/eo-core'
import { resetPassword } from '~/src/services/CustomerService'
import { ResetPasswordFormInterface } from '~/src/types/forms/ResetPasswordFormInterface'

interface ReturnsType {
  resetPassword(payload: ResetPasswordFormInterface, token: string, validity: string): Promise<BasicResponse | undefined>,
  errors: Record<string, HttpErrorMessageType[]> | string | null,
  loading: boolean,
}

const useResetPassword = (): ReturnsType => {
  const [ errors, setErrors ] = useState<Record<string, HttpErrorMessageType[]> | string | null>(null)
  const [ loading, setLoading ] = useState<boolean>(false)

  const action = async (payload: ResetPasswordFormInterface, token: string, validity: string): Promise<BasicResponse | undefined> => {
    setErrors(null)
    setLoading(true)

    try {
      const response: BasicResponse = await resetPassword(payload.password, payload.confirmPassword, token, validity)

      if (!response) {
        return
      }

      return response
    } catch (e: any | HttpError) {
      if (e?.errors) {
        setErrors(e.errors)
      } else if (e?.message) {
        setErrors(e.message)
      }
    } finally {
      setLoading(false)
    }
  }

  return { resetPassword: action, errors, loading }
}

export {
  useResetPassword
}
